import { InferType } from 'yup';
import {
  formResponseFailure,
  formResponseSuccess,
  formApiErrorTypeStrings,
} from './hubspot.validators';

type FormResponseFailure = InferType<typeof formResponseFailure>;
type FormResponseSuccess = InferType<typeof formResponseSuccess>;

export type FormApiErrorTypes = keyof typeof formApiErrorTypeStrings[number];

export interface LegalConsentCommunication {
  value: boolean,
  subscriptionTypeId: number,
  text: string,
}

export function isFormResponseFailure(
  candidate: unknown,
): candidate is FormResponseFailure {
  return formResponseFailure.isValidSync(candidate);
}

export function isFormResponseSuccess(
  candidate: unknown,
): candidate is FormResponseSuccess {
  return formResponseSuccess.isValidSync(candidate);
}

export function isLegalConsentCommunication(
  candidate: unknown,
): candidate is LegalConsentCommunication {
  return (
    typeof (candidate as LegalConsentCommunication)?.value === 'boolean' &&
    typeof (candidate as LegalConsentCommunication)?.subscriptionTypeId === 'number' &&
    typeof (candidate as LegalConsentCommunication)?.text === 'string'
  );
}

interface LegalConsentOptions {
  consent?: {
    consentToProcess: boolean,
    text: string,
    communications: LegalConsentCommunication[],
  },
  legitimateInterest?: {
    value: boolean,
    subscriptionTypeId: number,
    legalBasis: 'CUSTOMER' | 'LEAD',
    text: string,
  },
}

export interface HubspotField {
  name: string,
  value: any,
}

export interface Options {
  portalId: string,
  formGuid: string,
  fields: HubspotField[],
  legalConsentOptions: LegalConsentOptions,
  context?: {
    hutk?: string,
    ipAddress?: string,
    pageName?: string,
    pageUri?: string,
    pageId?: string,
    sfdcCampaignId?: string,
    goToWebinarWebinarKey?: string,
  },
  submittedAt?: string,
  skipValidation?: boolean,
}
